<template>
  <div>
    <!-- <v-icon >mdi-hexagon-outline</v-icon> -->
    <v-tooltip bottom color="rgba(21, 102, 124, 0.9)" >
      <template v-slot:activator="{ on, attrs }">
        <v-icon dark v-bind="attrs" v-on="on">
          mdi-information-outline
        </v-icon>
      </template>
			<table>
        <tbody>
				<tr>
					<th>
						Last Received UPS Track
					</th>
				</tr>
				<tr>
					<td>Device</td>
					<td><span>{{ device }}</span></td>
				</tr>
				<tr>
					<td>Source</td>
					<td><span>{{ source }}</span></td>
				</tr>
				<tr>
					<td>Lat</td>
					<td><span>{{ lat }}</span></td>
				</tr>
				<tr>
					<td>Lon</td>
					<td><span>{{ lon }}</span></td>
				</tr>
				<tr>
					<td>Date and Time</td>
					<td><span>{{ date }}</span></td>
				</tr>
        </tbody>
			</table>
    </v-tooltip>
  </div>
</template>

<script>
import { trackService } from "@/services/track.services.js";

export default {
  name: "LastReceived",
  data: () => ({
    device: null,
    source: null,
    lat: null,
    lon: null,
    date: null,
		userId: null
  }),
  props: {
    criteria: Object
  },
    watch: {
    criteria: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getStaffLastReceivedGpsTrackMethod(newValue);
      }
    },
  },
  methods: {
    getStaffLastReceivedGpsTrackMethod (criteria) {
      const me = this;
			this.userId = criteria.id
      trackService
        .getStaffLastReceivedGpsTrack(criteria)
        .then(function (response) {
          console.log("GPS Track data: ", response);
          console.log("special: ", response.data.features[0].properties.Device);

          if (response && response.data) {
            // me.staffLastGpsTrack = response.data.features[0].properties;
            me.device = response.data.features[0].properties.Device;
            me.source = response.data.features[0].properties.Source;
            me.lat = response.data.features[0].properties.Lat;
            me.lon = response.data.features[0].properties.Lon;
            me.date = response.data.features[0].properties.Time;
          }
        })
        .catch(function (e) {
          console.log("GPS Track Error");
          console.log(e);
        });
    }
  },
  beforeMount () {
    this.getStaffLastReceivedGpsTrackMethod(this.criteria);
  }
};
</script>
<style>
.v-tooltip__content {
  text-align: left;

}

</style>
